/* Velion Video Social Proof - eigene Steuerung.
   Der native Player wird nie aktiviert (kein controls-Attribut). Dadurch gibt es
   in keinem Browser einen Vollbild- oder Bild-in-Bild-Knopf - auch nicht in Safari,
   das controlsList und disablePictureInPicture ignoriert. */
(function () {
  'use strict';
  var START_VOLUME = 0.5;

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function initItem(it, items, pauseOthers) {
    var v = it.querySelector('video');
    if (!v) return;
    var q = function (s) { return it.querySelector(s); };
    var play = q('.velion-vsp__play'), slider = q('.velion-vsp__slider'), mute = q('.velion-vsp__mute');
    var pp = q('.velion-vsp__pp'), seek = q('.velion-vsp__seek');
    var cur = q('.velion-vsp__cur'), dur = q('.velion-vsp__dur');

    v.removeAttribute('controls');
    v.volume = START_VOLUME;
    it.classList.add('is-paused');

    var t = null;
    function poke() {
      it.classList.add('is-vol');
      clearTimeout(t);
      t = setTimeout(function () { it.classList.remove('is-vol'); }, 1500);
    }

    function syncVol() {
      var off = v.muted || v.volume === 0;
      it.classList.toggle('is-muted', off);
      if (slider) slider.value = Math.round(v.volume * 100);
      if (mute) mute.setAttribute('aria-pressed', off ? 'true' : 'false');
    }

    function start() {
      it.classList.add('is-playing');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (play) play.addEventListener('click', start);
    v.addEventListener('click', function () { v.paused ? start() : v.pause(); });

    if (pp) pp.addEventListener('click', function () { v.paused ? start() : v.pause(); });
    v.addEventListener('play', function () {
      it.classList.remove('is-paused');
      it.classList.add('is-playing');
      if (!pauseOthers) return;
      items.forEach(function (o) {
        if (o === it) return;
        var ov = o.querySelector('video');
        if (ov && !ov.paused) ov.pause();
      });
    });
    v.addEventListener('pause', function () { it.classList.add('is-paused'); });

    v.addEventListener('loadedmetadata', function () { if (dur) dur.textContent = fmt(v.duration); });
    v.addEventListener('timeupdate', function () {
      if (cur) cur.textContent = fmt(v.currentTime);
      if (seek && !seek.dataset.drag && v.duration) {
        seek.value = Math.round((v.currentTime / v.duration) * 1000);
      }
    });

    if (seek) {
      seek.addEventListener('pointerdown', function () { seek.dataset.drag = '1'; });
      seek.addEventListener('input', function () {
        if (v.duration) v.currentTime = (Number(seek.value) / 1000) * v.duration;
      });
      seek.addEventListener('change', function () { delete seek.dataset.drag; });
    }

    if (slider) {
      slider.addEventListener('input', function () {
        var val = Number(slider.value) / 100;
        v.volume = val;
        v.muted = val === 0;
        syncVol();
        poke();
      });
      slider.addEventListener('focus', poke);
    }

    if (mute) mute.addEventListener('click', function () {
      if (v.muted || v.volume === 0) {
        v.muted = false;
        if (v.volume === 0) v.volume = START_VOLUME;
      } else {
        v.muted = true;
      }
      syncVol();
      poke();
    });

    v.addEventListener('volumechange', syncVol);
    syncVol();
  }

  function boot(root) {
    (root || document).querySelectorAll('.velion-vsp').forEach(function (w) {
      if (w.dataset.vVid === '1') return;
      w.dataset.vVid = '1';
      var items = Array.prototype.slice.call(w.querySelectorAll('.velion-vsp__item'));
      var pauseOthers = w.dataset.pauseOthers === 'true';
      items.forEach(function (it) { initItem(it, items, pauseOthers); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target.parentNode || document); });
})();
